// extracted by mini-css-extract-plugin
export default {"root":"QuizImage_root__THEE6","animateRotation":"QuizImage_animateRotation__QS0jd","rotate":"QuizImage_rotate__tf8kL"};